import React from "react";
import styled from "styled-components/macro";
import { HoverableText } from "theme/GlobalElements";
import { MdArrowDropDown } from "react-icons/md";
import { bgFade } from "theme/Animations";

interface DropdownProps {
  title: string;
  children: any;
}

const DropdownItem: React.FC<DropdownProps> = ({ title, children }) => {
  return (
    <DropdownContainer>
      <MenuItem>
        <HoverableText className="text-body" title={title} color="white">
          {title}
        </HoverableText>
        <MdArrowDropDown color="white" size="1.5em" />
      </MenuItem>

      <DropdownDataContainer>
        <DataWrapper>
          <Data>{children}</Data>
        </DataWrapper>
      </DropdownDataContainer>
    </DropdownContainer>
  );
};

const DropdownContainer = styled.div`
  cursor: pointer;
  position: relative;
  display: inline-block;
`;

export const MenuItem = styled.div`
  padding-right: 20px;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  ${DropdownContainer}:hover & {
    font-weight: 600;
  }
  svg {
    display: inline-flex;
    justify-content: center;
    transform: rotate(0deg);
    transition: transform 0.15s linear;
    ${DropdownContainer}:hover & {
      transform: rotate(180deg);
      transition: transform 0.15s linear;
    }
  }
`;

const DropdownDataContainer = styled.div`
  position: absolute;
  min-width: 160px;
  z-index: 10;
  display: none;

  ${DropdownContainer}:hover & {
    animation: ${bgFade} 0.3s ease-out;
    display: block;
  }
`;

const DataWrapper = styled.div`
  margin-top: 12px;
  background-color: #f5f5f5;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);

  &::before {
    content: "";
    border-style: solid;
    border-width: 10px 10px 10px 20px;
    border-color: transparent #f5f5f5 transparent transparent;
    position: absolute;
    transform: rotate(90deg);
    top: -10px;
  }
`;

const Data = styled.div`
  padding: 10px;
`;

export default DropdownItem;
